module.exports = __webpack_public_path__ + "static/media/8.e73ecb5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/8.png
// module id = 923
// module chunks = 0